import Box from '@mui/material/Box';

// 3 mph in m/s, matching the backend's LocationHistory::IDLE_SPEED_THRESHOLD.
// Speeds on pings are stored in m/s, so the threshold is converted from mph here.
const MS_PER_MPH = 0.44704;
const IDLE_SPEED_THRESHOLD_MPH = 3;
const IDLE_SPEED_THRESHOLD_MS = IDLE_SPEED_THRESHOLD_MPH * MS_PER_MPH;
// Matches idle truck icon border and v2 status chips.
const IDLE_COLOR = '#D9A64D';

type IdleThresholdProps = {
  maxSpeed: number;
};

export const IdleThreshold = ({ maxSpeed }: IdleThresholdProps) => {
  if (maxSpeed <= IDLE_SPEED_THRESHOLD_MS) {
    return null;
  }

  const top = `${(1 - IDLE_SPEED_THRESHOLD_MS / maxSpeed) * 100}%`;

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: top,
          bottom: 0,
          backgroundColor: IDLE_COLOR,
          opacity: 0.08,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: top,
          borderTop: `1px dashed ${IDLE_COLOR}`,
          pointerEvents: 'none',
        }}
      />
    </>
  );
};
